import React, { useEffect, useState } from "react";
import Styles from "./ContractDetails.module.css";
import { useDispatch, useSelector } from "react-redux";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { convertDate, formatDateType } from "../../../../commons/FormatDate";
import { useNavigate } from "react-router-dom";
import ChildTransaction from "../../../Modals/Payment/ChildTransaction/ChildTransaction";
import { walletChildTransaction } from "../../../../Services/Payments/PaymentApi";
import { ErrorMessage } from "../../../../commons/Toast/ErrorMessage";
import Skeleton from "@mui/material/Skeleton";
import {
  walletAccount,
  walletContract,
  walletTransaction,
} from "../../../../Redux/Slices/paymentSlice";

const ContractDetails = () => {
  const navigate = useNavigate();
  const role = useSelector(
    (state) => state?.persistedReducer?.user?.activeRole,
  ).toLowerCase();
  const dispatch = useDispatch();
  const data = useSelector((state) => state?.paymentSlice);
  let transaction = data?.walletTransaction;
  let contracts = data?.walletContract;
  let loading = data?.walletContractLoading || data?.walletTransactionLoading;
  const wallet = useSelector(
    (state) => state?.paymentSlice?.walletAccountActive,
  );

  const [childTransaction, setChildTransaction] = useState([]);
  const [parentData, setParentData] = useState({});

  useEffect(() => {
    dispatch(walletTransaction({ page: 0, size: 10 }));
    if (wallet?.id) {
      dispatch(walletContract({ id: wallet?.id, page: 0, size: 10 }));
    }
  }, [dispatch, wallet?.id]);

  const handleNav = (val) => {
    navigate(val);
  };

  const handleChildTransaction = async (data) => {
    setParentData(data);
    let res = await walletChildTransaction(data?.id);
    if (res?.data?.code === 200) {
      setChildTransaction(res?.data?.data || []);
    } else {
      ErrorMessage(res?.data?.error || "Something went wrong");
    }
  };

  return (
    <>
      {
        <ChildTransaction
          open={childTransaction?.length > 0}
          handleClose={() => setChildTransaction([])}
          data={childTransaction}
          parentData={parentData}
        />
      }
      <div className={`display_flex_column ${Styles.detailsMainContainer}`}>
        <div>
          <div className={`display_flex_row ${Styles.containerHeading}`}>
            <div>Contracts</div>
            <div
              className={Styles.viewAll}
              onClick={() => handleNav("/wallet_contract")}
            >
              View All
            </div>
          </div>
          <div className={Styles.tableMainElem}>
            <div
              className={`display_flex_row tableHeading ${Styles.headingMainTable}`}
            >
              <div style={{ width: "10%" }}>Contract Id</div>
              <div style={{ width: "10%" }}>Self Lisitng</div>
              <div style={{ width: "10%" }}>Counterparty</div>
              <div style={{ width: "10%" }}>Start and End Date</div>
              <div style={{ width: "10%" }}>Total Contract Value (₹)</div>
              <div style={{ width: "10%" }}>Amount Blocked (₹)</div>
              <div style={{ width: "10%" }}>Total Contract Schedule (MWH)</div>
              <div style={{ width: "10%" }}>Actual Delivery (MWH)</div>
              <div style={{ width: "10%" }}>Schedule</div>
              <div style={{ width: "5%" }}>Details</div>
            </div>
            <div className={`scroll_bar_y ${Styles.viewMainElem}`}>
              {loading ? (
                Array.from({ length: 3 }).map((_, idx) => (
                  <div className="display_flex_row tableDetails" key={idx}>
                    <div style={{ width: "10%" }}></div>
                    <div style={{ width: "10%" }}>
                      <Skeleton variant="text" width={60} height={20} />
                    </div>
                    <div style={{ width: "20%" }}>
                      <Skeleton variant="text" width={120} height={20} />
                    </div>
                    <div style={{ width: "10%" }}>
                      <Skeleton variant="text" width={60} height={20} />
                    </div>
                    <div style={{ width: "10%" }}>
                      <Skeleton variant="text" width={60} height={20} />
                    </div>
                    <div style={{ width: "15%" }}>
                      <Skeleton variant="text" width={80} height={20} />
                    </div>
                    <div style={{ width: "15%" }}>
                      <Skeleton variant="text" width={80} height={20} />
                    </div>
                    <div style={{ width: "10%" }}>
                      <Skeleton variant="text" width={60} height={20} />
                    </div>
                    <div style={{ width: "5%" }}>
                      <Skeleton variant="circular" width={20} height={20} />
                    </div>
                  </div>
                ))
              ) : contracts?.length > 0 && contracts !== null ? (
                contracts?.map((ele) => (
                  <div className="display_flex_row tableDetails" key={ele?.id}>
                    <div style={{ width: "10%" }}>
                      {" "}
                      {ele?.bilateralContractUniqueId || "-"}
                    </div>
                    <div style={{ width: "10%" }}>
                      {(role === "consumer"
                        ? ele?.name?.split("-")?.[0]?.includes("C")
                          ? ele?.name?.split("-")?.[0]
                          : ele?.name?.split("-")?.[1]
                        : ele?.name?.split("-")?.[1]?.includes("G")
                          ? ele?.name?.split("-")?.[1]
                          : ele?.name?.split("-")?.[0]
                      )?.split("_")?.[0] || "-"}
                    </div>
                    <div style={{ width: "10%" }}>
                      {role === "consumer"
                        ? `${ele?.generatorName || "-"}`
                        : role === "generator"
                          ? `${ele?.consumerName || "-s"}`
                          : `${ele?.consumerName}-${ele?.generatorName}`}
                    </div>
                    <div style={{ width: "10%" }}>
                      {`${formatDateType(ele?.startDate)} to ${formatDateType(
                        ele?.endDate,
                      )}`}
                    </div>
                    <div style={{ width: "10%" }}>
                      {ele?.scheduledAmount?.toFixed(2)}
                    </div>
                    <div style={{ width: "10%" }}>
                      {(ele?.amountBlocked || 0)?.toFixed(2)}
                    </div>
                    <div style={{ width: "10%" }}>
                      {(ele?.scheduledVolume || 0)?.toFixed(2)}
                    </div>
                    <div style={{ width: "10%" }}>
                      {(ele?.deliveredVolume || 0)?.toFixed(2)}
                    </div>
                    <div
                      style={{ width: "10%" }}
                      className={`${
                        ele?.status === "COMPLETED"
                          ? "accepted"
                          : ele?.status === "PENDING"
                            ? "pending"
                            : "rejected"
                      }`}
                    >
                      {ele?.status === "COMPLETED"
                        ? "Completed"
                        : ele?.status === "PENDING"
                          ? "Ongoing"
                          : "Rejected"}
                    </div>
                    <div
                      style={{ width: "5%" }}
                      onClick={() => {
                        handleChildTransaction(ele);
                      }}
                    >
                      <VisibilityIcon
                        style={{ fontSize: "14px", color: "#f1935c" }}
                      />
                    </div>
                  </div>
                ))
              ) : (
                <div className={Styles.noData}>No contracts available</div>
              )}
            </div>
          </div>
        </div>
        <div>
          <div className={`display_flex_row ${Styles.containerHeading}`}>
            <div>Transactions</div>
            <div
              className={Styles.viewAll}
              onClick={() => handleNav("/wallet_transaction")}
            >
              View All
            </div>
          </div>
          <div className={Styles.tableMainElem}>
            <div
              className={`display_flex_row tableHeading ${Styles.headingMainTable}`}
            >
              <div style={{ width: "15%" }}>Self Listing</div>
              <div style={{ width: "15%" }}>Counterparty Name</div>
              <div style={{ width: "15%" }}>Contract Id</div>
              <div style={{ width: "15%" }}>Transaction Date</div>
              <div style={{ width: "15%" }}>Transaction Amount (₹)</div>
              <div style={{ width: "10%" }}>Type</div>
              <div style={{ width: "10%" }}>Action</div>
              {/* <div style={{ width: "35%" }}>Comments</div> */}
            </div>
            <div className={`scroll_bar_y ${Styles.viewMainElem}`}>
              {loading ? (
                Array.from({ length: 3 }).map((_, idx) => (
                  <div className="display_flex_row tableDetails" key={idx}>
                    <div style={{ width: "10%" }}>
                      <Skeleton variant="text" width={30} height={20} />
                    </div>
                    <div style={{ width: "20%" }}>
                      <Skeleton variant="text" width={100} height={20} />
                    </div>
                    <div style={{ width: "20%" }}>
                      <Skeleton variant="text" width={80} height={20} />
                    </div>
                    <div style={{ width: "10%" }}>
                      <Skeleton variant="text" width={40} height={20} />
                    </div>
                    <div style={{ width: "35%" }}>
                      <Skeleton variant="text" width={120} height={20} />
                    </div>
                  </div>
                ))
              ) : transaction?.length > 0 ? (
                transaction?.map((ele, index) => (
                  <div
                    className="display_flex_row tableDetails"
                    key={ele?.id || index}
                  >
                    <div style={{ width: "15%" }}>
                      {ele?.listingId?.split("_")?.[0] || "-"}
                    </div>
                    <div style={{ width: "15%" }}>
                      <div>
                        {(ele?.counterPartyName === "UNKNOWN"
                          ? ""
                          : ele?.counterPartyName) || "-"}
                      </div>
                      {ele?.counterPartyListingId && (
                        <div style={{ fontSize: "8px" }}>
                          {ele?.counterPartyListingId || "-"}
                        </div>
                      )}
                    </div>
                    <div style={{ width: "15%" }}>
                      {ele?.bilateralContractUniqueId || "Not Generated"}
                    </div>
                    <div style={{ width: "15%" }}>
                      {convertDate(ele?.dateTime?.split(" ")?.[0])} <br />
                      {ele?.dateTime?.split(" ")?.[1]}
                    </div>
                    <div style={{ width: "15%" }}>
                      {ele?.amount?.toFixed(2)}
                    </div>
                    <div
                      style={{
                        width: "10%",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {ele?.paymentType?.split("_")?.join(" ") || "-"}
                    </div>
                    <div
                      style={{ width: "10%" }}
                      className={
                        ele?.activity === "CREDIT" ||
                        ele?.activity === "RELEASED"
                          ? "accepted"
                          : "rejected"
                      }
                    >
                      {ele?.activity}
                    </div>
                  </div>
                ))
              ) : (
                <div className={Styles.noData}>No transactions available</div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ContractDetails;
